import { gql } from '@apollo/client';

const DIVISIONS_QUERY = gql`
  query divisions($countryCode: String!, $limit: Int) {
    divisions(countryCode: $countryCode, limit: $limit) {
      name
      fullCode
      code
    }
  }
`;

export default DIVISIONS_QUERY;
